import {MUTATION_KEYS} from '@/queryClient'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpChangeAccountEmail, HttpChangeAccountEmailOptions} from './account.http'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {AuthUser} from '@/features/auth/types'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'

export const useChangeAccountEmail = ({
    urlParams,
    options
}: {
    urlParams: HttpChangeAccountEmailOptions['urlParams']
    options?: UseMutationOptions<AuthUser, AxiosError<ErrorResponseData>, HttpChangeAccountEmailOptions['payload']>
}) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CHANGE_ACCOUNT_EMAIL],
        mutationFn: payload =>
            parseAxiosPromise({
                axiosPromise: httpChangeAccountEmail({urlParams, payload}),
                onZodError: captureException,
                responseShape: AuthUser
            })
    })
